import { atom, useAtom, useSetAtom } from "jotai";
import { OrderUser } from "../utils/interfaces";
import { PrimitiveAtom } from "jotai/vanilla";

interface IOrderUser
  extends Omit<
    OrderUser,
    "house_number" | "house_number_extension" | "branch_id"
  > {
  day?: string;
  time?: string;
  house_number: string;
  house_number_extension?: string;
}

export const defaultPosOrderUser = null;
export const posOrderUserAtom = atom<IOrderUser>(
  defaultPosOrderUser
) as PrimitiveAtom<IOrderUser>;

const usePosOrderUser = () => {
  const atom = useAtom(posOrderUserAtom);
  return atom;
};

export const useSetPosOrderUser = () => useSetAtom(posOrderUserAtom);

export default usePosOrderUser;
